import { baseUrl } from "../constants";
import apiFunctions from "./axiosConfig/apiFunctions";
import CustomToast from "../components/Toast";

 export const fetchCaseStudyData = async (searchtext) => {
    try {
      // GET request
      searchtext=searchtext?.length>1?searchtext:'';
      const responseGet = await apiFunctions.fetchData(`${baseUrl}getCaseStudyList?pageNumber=1&limit=100&search=${searchtext}`);
      return responseGet;
    } catch (error) {
      CustomToast.error('Error while fetcing Case Study data')
        return error;
    } 
  };

  //   export const createCaseStudy = async (postData) => {
  //   try {
  //     // POST request
  //     const responseGet = await apiFunctions.postData(`${baseUrl}createCaseStudy`,postData);
  //     // CustomToast.success('Case Study data saved successfully')
  //     return responseGet;
  //   } catch (error) {
  //       // CustomToast.error('Error while save Case Study data')
  //       return error;
  //   } 
  // };

  export const createCaseStudy = async (postData) => {
  try {
    const response = await apiFunctions.postData(`${baseUrl}createCaseStudy`, postData);
    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    const message = error?.response?.data?.message || 'Unexpected error occurred.';
    return {
      success: false,
      message,
    };
  }
};


   export const deleteCaseStudie = async (id) => {
  try {
    // DELETE request
    const responseGet = await apiFunctions.deleteData(`${baseUrl}deleteCaseStudies/${id}`);
    CustomToast.success('Case Study deleted successfully');
    return responseGet;
  } catch (error) {
    CustomToast.error('Error while deleting Case Study');
    return error;
  }
};

  export const updateCaseStudies = async (id, updatedData) => {
  try {
    const response = await apiFunctions.putData(`${baseUrl}updateCaseStudies/${id}`, updatedData);
    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    const message = error?.response?.data?.message || 'Unexpected error occurred.';
    return {
      success: false,
      message,
    };
  }
};

export const publishCaseStudies = async (id, data) => {
  try {
    const response = await apiFunctions.putData(`${baseUrl}publishCaseStudies/${id}`, data);
    // CustomToast.success('Case Study published successfully');
    return response;
  } catch (error) {
    // CustomToast.error('Error while publishing Case Study');
    return error;
  }
};

export const getCaseStudyDetails = async (id) => {
  try {
    const response = await apiFunctions.fetchData(`${baseUrl}caseStudyDetails/${id}`);
    return response;
  } catch (error) {
    CustomToast.error('Error while fetching Case Study details');
    return error;
  }
};

export const deleteUploadedFile = async (id) => {
  try {
    const response = await apiFunctions.deleteData(`${baseUrl}deleteCaseStudyUploadFile/${id}`);
    return response.data;
  } catch (error) {
    console.error("Failed to delete file:", error);
    throw error;
  }
};

